import { getSupabaseClient } from '../../lib/supabase'

export type ProspectStage = 'new'|'contacted'|'demo_scheduled'|'demo_completed'|'trial'|'converted'|'lost'
export type ProspectSegment = 'owner'|'investor'|'property_manager'
export type ProspectActivityType = 'note'|'outreach'|'demo'|'objection'|'follow_up'|'conversion'

export type RevenueProspect = {
  id: string
  name: string
  email: string
  company_name: string|null
  phone: string|null
  segment: ProspectSegment
  stage: ProspectStage
  urgent_problem: string
  next_action: string|null
  next_action_on: string|null
  created_at: string
}

export type RevenueDashboard = {
  summary: { prospects: number; demos: number; trials: number; converted: number }
  prospects: RevenueProspect[]
  activities: Array<{ id:string; prospect_id:string; activity_type:string; notes:string; occurred_at:string }>
  enrollments: Array<{ id:string; organization_id:string; status:string; guarantee_ends_at:string }>
}

export async function getFoundingAvailability() {
  const { data, error } = await getSupabaseClient().rpc('get_founding_program_availability')
  if (error) throw error
  return data as unknown as { capacity:number; enrolled:number; remaining:number }
}

export async function submitFoundingInterest(input: {
  name:string; email:string; company:string; phone:string; segment:ProspectSegment; problem:string
}) {
  const { data, error } = await getSupabaseClient().rpc('submit_founding_customer_interest', {
    prospect_name: input.name,
    prospect_email: input.email,
    prospect_company: input.company,
    prospect_phone: input.phone,
    prospect_segment: input.segment,
    prospect_problem: input.problem,
  })
  if (error) throw error
  return data
}

export async function getRevenueDashboard() {
  const { data, error } = await getSupabaseClient().rpc('get_revenue_launch_dashboard')
  if (error) throw error
  return data as unknown as RevenueDashboard
}

export async function updateProspectStage(id:string, stage:ProspectStage) {
  const changes = stage === 'demo_completed'
    ? { stage, demo_completed_at: new Date().toISOString() }
    : { stage }
  const { error } = await getSupabaseClient().from('revenue_prospects').update(changes).eq('id', id)
  if (error) throw error
}

export async function addProspectActivity(prospectId:string, notes:string, activityType:ProspectActivityType='note') {
  const { data:userData } = await getSupabaseClient().auth.getUser()
  const { error } = await getSupabaseClient().from('revenue_activities').insert({
    prospect_id: prospectId,
    activity_type: activityType,
    notes,
    created_by: userData.user?.id ?? null,
  })
  if (error) throw error
}
